import request from '@/router/axios';

export const add = (row) => {
  return request({
    url: '/api/produce/weidu-device-info/insert',
    method: 'post',
    data: row
  })
}
export const update = (row) => {
  return request({
    url: '/api/produce/weidu-device-info/update',
    method: 'post',
    data: row
  })
}
export const getDetail = (id) => {
  return request({
    url: '/api/produce/weidu-device-info/selectId',
    method: 'get',
    params: {
      id
    }
  })
}
export const getList = (params) => {
  return request({
    url: '/api/produce/weidu-device-info/selectPage',
    method: 'get',
    params
  })
}
export const exportExcel = (params) => {
  return request({
    url: '/api/produce/weidu-device-info/export/excel',
    method: 'post',
    params,
    responseType: 'blob'
  })
}

export const remove = (ids) => {
  return request({
    url: '/api/produce/weidu-device-info/deleteIds',
    method: 'get',
    params: {
      ids
    }
  })
}

